import { useSelector } from 'react-redux';
import { Dropdown } from '../shared';
import { selectLang } from '../../store/ui/ui.selector';
import { selectTaxonomyGroups } from '../../store/utils/utils.selector';
import { translate } from '../../lib/lang.helper';

interface Props {
  value: number[];
  onChange: (ids: number[]) => void;
  className?: string;
  hideLabel?: boolean;
}

const TaxonomyGroupFilter = ({
  value,
  onChange,
  className,
  hideLabel = false,
}: Props) => {
  const lang = useSelector(selectLang);
  const taxonomyGroups = useSelector(selectTaxonomyGroups);

  if (!taxonomyGroups || taxonomyGroups.length === 0) return null;

  return (
    <Dropdown
      className={className}
      label={hideLabel ? '' : translate(lang, 'Taxonomy groups')}
      mode='multiple'
      placeholder={translate(lang, 'All taxonomy groups')}
      options={taxonomyGroups.map(x => ({
        id: x.id.toString(),
        value: x.id.toString(),
        label: x.name,
      }))}
      value={value.map(String) as any}
      onChange={(vals: any) => onChange((vals as string[]).map(Number))}
      allowClear={true}
    />
  );
};

export default TaxonomyGroupFilter;
